import {put, call, select} from "redux-saga/effects";
import * as api from "services/api";
import {getErrorFromMessage} from "services/utils/utils";
import {
    getPrivateProfileFailure,
    getPrivateProfileRecommendationSuccess,
    getPrivateProfileSuccess
} from "features/pages/single-people/reducer";
import {privateProfileSlugSelector} from "features/pages/single-people/selectors";

export function* getPrivateProfileSaga({payload}) {
    const {slug} = payload;
    try {
        const data = yield call([api, api.getPrivateProfile], slug);
        yield put(getPrivateProfileSuccess(data));
    } catch (e) {
        console.log(e);
        yield put(getPrivateProfileFailure(getErrorFromMessage(e)));
    }
}
export function* getPrivateProfileRecommendationStatusSaga() {
    const slug = yield select(privateProfileSlugSelector);
    try {
        const data = yield call([api, api.getPrivateProfileRecommendation], slug);
        yield put(getPrivateProfileRecommendationSuccess(data));
    } catch (e) {
        console.log(e);
    }
}